function getPaymentStatusTagText(status) {
  switch (status) {
    case paymentStatusEnum.PAID:
      return 'Shift has been paid.'
    case paymentStatusEnum.DRAFT:
      return 'Payment is in draft status.'
    case paymentStatusEnum.NOT_PAID:
      return 'Shift has not been paid.'
    case paymentStatusEnum.CANCELLED:
      return 'Payment was rejected.'
    case paymentStatusEnum.IN_PROGRESS:
      return 'Payment processing is in progress.'
    default:
      return 'Unknown status.'
  }
}

function capitalizeWords(str) {
  return str.replace(/\b\w/g, char => char.toUpperCase())
}

export const shiftStatusEnum = Object.freeze({
  SCHEDULED: 'scheduled',
  STARTED: 'started',
  MISSED: 'missed',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  DELETED: 'deleted'
})

export const paymentStatusEnum = Object.freeze({
  PAID: 'paid',
  DRAFT: 'draft',
  NOT_PAID: 'not_paid',
  CANCELLED: 'cancelled',
  IN_PROGRESS: 'in_progress',
  PARTIALLY_PAID: 'partially_paid'
})

export const statusTagColors = Object.freeze({
  GREEN: '#10b981',
  GRAY: '#6b7280',
  RED: '#ef4444',
  LILAC: '#6c69ff',
  TURTLE: '#21e29d',
  ORANGE: '#f59e0b',
  BLUE_LIGHT: '#3b82f6'
})

export const problematicAssociatesMap = Object.freeze({
  suspected: 'Suspicious Time',
  with_writeups: 'With Written Warnings',
  with_declined_auths: 'With Declined Violations'
})

export const authorizationsMap = Object.freeze({
  no_lunch_authorization: {
    label: 'No Meal Break',
    approvedLabel: 'Meal Break Not Required',
    color: '#1abc9c'
  },
  no_second_lunch_authorization: {
    label: 'No 2nd Meal Break',
    approvedLabel: '2nd Meal Break Not Required',
    color: '#e67e22'
  },
  late_end_authorization: {
    label: 'Late End',
    approvedLabel: 'Approved Late End',
    color: '#f59e0b'
  },
  early_start_authorization: {
    label: 'Early Start',
    approvedLabel: 'Approved Early Start',
    color: '#3498db'
  },
  early_lunch_end_authorization: {
    label: 'Short Meal Break',
    approvedLabel: 'Approved Short Meal Break',
    color: '#f1c40f'
  },
  early_second_lunch_end_authorization: {
    label: 'Short 2nd Meal Break',
    approvedLabel: 'Approved Short 2nd Meal Break',
    color: '#e74c3c'
  },
  no_actual_time_authorization: {
    label: 'Missed Tracked Time',
    approvedLabel: 'Approved Tracked Time',
    color: '#f59e0b'
  },
  overtime_authorization: {
    label: 'Unscheduled Overtime',
    approvedLabel: 'Approved Overtime',
    color: '#7f8c8d'
  },
  edit_shift_authorization: {
    label: 'Edit Shift',
    approvedLabel: '',
    color: '#21e29d'
  },
  shift_info: { label: 'Shift Info', approvedLabel: '', color: '#21e29d' },
  outside_work_area_authorization: {
    label: 'Outside Work Area',
    approvedLabel: 'In Work Area',
    color: '#34495e'
  },
  short_shift_authorization: {
    label: 'Short Shift',
    approvedLabel: 'Approved Short Shift',
    color: '#6b7280'
  },
  employee_issue: {
    label: 'Employee Issue',
    approvedLabel: '',
    color: '#21e29d'
  },
  late_start_authorization: {
    label: 'Late Start',
    approvedLabel: 'Approved Late Start',
    color: '#d47aff'
  },
  early_end_authorization: {
    label: 'Early End',
    approvedLabel: 'Approved Early End',
    color: '#6b7280'
  },
  first_lunch_period_authorization: {
    label: 'First Meal Break Period',
    approvedLabel: 'Approved Meal Break Period',
    color: '#f1c40f'
  },
  signed_actual_time_discrepancy: {
    label: 'Adjusted Track Time',
    approvedLabel: 'Track Time Correct',
    color: '#f59e0b'
  },
  no_rest_break_authorization: {
    label: 'No Rest Breaks',
    approvedLabel: 'Rest Breaks Not Required',
    color: '#f59e0b'
  },
  manually_shift_authorization: {
    label: 'Manually Shift',
    approvedLabel: '',
    color: '#f59e0b'
  },
  associate_not_recognized_authorization: {
    label: 'Associate Not Recognized',
    approvedLabel: 'Associate Recognized'
  },
  // uncompleted_required_tasks_authorization: {
  //   label: "Uncompleted Tasks",
  //   approvedLabel: "Tasks Not Required",
  // },
  unscheduled_shift_authorization: {
    label: 'Unscheduled Shift',
    approvedLabel: 'Scheduled Shift'
  }
})

export const shiftStatusesMap = Object.freeze({
  scheduled: { label: 'Scheduled', color: '#6b7280' },
  started: { label: 'Started', color: '#3b82f6' },
  missed: { label: 'Missed', color: '#ef4444' },
  completed: { label: 'Completed', color: '#10b981' },
  deleted: { label: 'Deleted', color: '#ef4444' },
  cancelled: { label: 'Cancelled', color: '#ef4444' }
})

export const paymentStatusesMap = Object.freeze({
  not_paid: { label: 'Ready To Pay', color: '#10b981' },
  in_progress: { label: 'Payment In Progress', color: '#3b82f6' },
  paid: { label: 'Paid', color: '#6b7280' },
  draft: { label: 'Draft', color: '#21E29D' },
  partially_paid: { label: 'Partially Paid', color: '#6b7280' },
  cancelled: { label: 'Payment Rejected', color: '#ef4444' }
})

export const paymentRequestPaymentStatusesMap = Object.freeze({
  created: { label: 'Created', color: '#6b7280' },
  processing: { label: 'Processing', color: '#f59e0b' },
  confirmed: { label: 'Confirmed', color: '#3b82f6' },
  accepted: { label: 'Accepted', color: '#10b981' },
  cancelled: { label: 'Rejected', color: '#ef4444' },
  pending: { label: 'Pending', color: '#f59e0b' },
  completed: { label: 'Completed', color: '#10b981' }
})

export const paymentMethodsMap = Object.freeze({
  check: { label: 'Check', color: '#ef4444' },
  cash: { label: 'Cash', color: '#10b981' },
  bank_transfer: { label: 'Bank Transfer', color: '#3b82f6' },
  online_payment: { label: 'Online Payment', color: '#f59e0b' }
})

export const associateStatusMap = Object.freeze({
  scheduled_shift: 'Scheduled Shift',
  work: 'Work',
  lunch: 'Meal Break',
  second_lunch: 'Second Meal Break',
  complete_shift: 'Complete Shift',
  mileage: 'Tracking Mileage',
  missed: 'Missed Shift',
  outside: 'Outside'
})

export const associateStatusColorsMap = Object.freeze({
  scheduled_shift: '#6b7280',
  work: '#10b981',
  lunch: '#10b981',
  second_lunch: '#10b981',
  complete_shift: '#10b981',
  mileage: '#6b7280',
  missed: '#ef4444',
  outside: '#6b7280'
})

export const statusColors = {
  GRAY: [shiftStatusEnum.SCHEDULED],
  GREEN: [paymentStatusEnum.NOT_PAID, shiftStatusEnum.COMPLETED],
  RED: [shiftStatusEnum.MISSED, shiftStatusEnum.CANCELLED, shiftStatusEnum.DELETED, paymentStatusEnum.CANCELLED],
  ORANGE: [],
  BLUE_LIGHT: [shiftStatusEnum.STARTED, paymentStatusEnum.IN_PROGRESS, paymentStatusEnum.PAID]
}

export const vueTourOptions = {
  highlight: true,
  labels: {
    buttonPrevious: 'Back',
    buttonNext: 'Next',
    buttonStop: 'Finish',
    buttonSkip: 'Skip Guide'
  }
}

export const writeUpStatuses = Object.freeze({
  signed: { label: 'Signed', color: '#10b981' },
  acknowledged: { label: 'Acknowledged', color: '#3b82f6' },
  not_signed: { label: 'Unacknowledged', color: '#ef4444' }
})

export const violationCategories = [
  {
    label: 'Attendance or Tardiness',
    key: 'attendance_or_tardiness',
    value: 'attendance_or_tardiness'
  },
  {
    label: 'Work Quality',
    key: 'work_quality',
    value: 'work_quality'
  },
  {
    label: 'Insubordination',
    key: 'insubordination',
    value: 'insubordination'
  },
  {
    label: 'Safety',
    key: 'safety',
    value: 'safety'
  }
]

export const sequenceStepTypes = Object.freeze({
  sign_document: 'Sign Document',
  attach_file: 'Attach File',
  survey: 'Quiz'
})

export function getShiftStatusTagText(status) {
  switch (status) {
    case shiftStatusEnum.SCHEDULED:
      return 'Shift has been scheduled.'
    case shiftStatusEnum.STARTED:
      return 'Shift is currently in progress.'
    case shiftStatusEnum.MISSED:
      return 'Shift has been missed.'
    case shiftStatusEnum.CANCELLED:
      return 'Shift has been cancelled.'
    case shiftStatusEnum.DELETED:
      return 'Shift has been deleted.'
    case shiftStatusEnum.COMPLETED:
      return 'Shift has been completed.'
    default:
      return getPaymentStatusTagText(status)
  }
}

export function getShiftStatusTagLabel(status) {
  switch (status) {
    case shiftStatusEnum.SCHEDULED:
      return 'Scheduled'
    case shiftStatusEnum.STARTED:
      return 'Started'
    case shiftStatusEnum.MISSED:
      return 'Missed'
    case shiftStatusEnum.CANCELLED:
      return 'Cancelled'
    case shiftStatusEnum.COMPLETED:
      return 'Completed'
    case shiftStatusEnum.DELETED:
      return 'Deleted'
    default:
      return tryToGetPaymentStatusTagText(status)
  }
}

export function tryToGetPaymentStatusTagText(status) {
  switch (status) {
    case paymentStatusEnum.PAID:
      return 'Paid'
    case paymentStatusEnum.DRAFT:
      return 'Draft'
    case paymentStatusEnum.NOT_PAID:
      return 'Ready To Pay'
    case paymentStatusEnum.CANCELLED:
      return 'Payment Rejected'
    case paymentStatusEnum.IN_PROGRESS:
      return 'Payment In Progress'
    case paymentStatusEnum.PARTIALLY_PAID:
      return 'Partially Paid'
    default:
      return capitalizeWords(status)
  }
}

export function getAuthStatusTagColor(status) {
  const combinedStatusMap = { ...shiftStatusesMap, ...paymentStatusesMap }
  const lowercasedStatus = status.toLowerCase()

  if (combinedStatusMap[lowercasedStatus]) {
    return combinedStatusMap[lowercasedStatus].color
  } else {
    return '#6b7280'
  }
}
